import { render, staticRenderFns } from "./student_current_info.vue?vue&type=template&id=5ea8b735&scoped=true&"
import script from "./student_current_info.vue?vue&type=script&lang=js&"
export * from "./student_current_info.vue?vue&type=script&lang=js&"
import style0 from "./student_current_info.vue?vue&type=style&index=0&id=5ea8b735&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea8b735",
  null
  
)

export default component.exports